document.addEventListener('DOMContentLoaded', () => {
    const filters = document.querySelectorAll('a[data-filter]');
    const items = document.querySelectorAll('.collection__content--inner');
    const menus = document.querySelectorAll('.collection__content--active-filter');
    const applyBtn = document.querySelector('.button-apply');

    // Internal state for "staged" (draft) selections
    let stagedFilters = [];

    const isMobile = () => window.innerWidth < 1000;

    /**
     * CORE LOGIC: Syncs everything to the URL
     */
    const applyFilter = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const activeFilters = urlParams.get('filters') ? urlParams.get('filters').split(',') : [];
        
        // Sync our draft with the actual applied filters
        stagedFilters = [...activeFilters];

        // 1. Sync Anchor Links & Parent Classes
        filters.forEach(link => {
            const val = link.getAttribute('data-filter');
            const isActive = activeFilters.includes(val);
            link.classList.toggle('selected', isActive);
            if (link.parentElement) {
                link.parentElement.classList.toggle('selected', isActive);
            }
        });

        // 2. Update the "Active Filters" Menu (Tags)
        menus.forEach(menu => {
            if (!menu) return;
            if (activeFilters.length === 0 || (activeFilters.length === 1 && activeFilters[0] === "")) {
                menu.innerHTML = '';
            } else {
                const tagsHtml = activeFilters.filter(f => f !== "").map(f => `
                    <span class="filter-tag subheading">
                        ${f.replace(/-/g, ' ')} 
                        <span class="remove-filter" data-remove="${f}">&times;</span>
                    </span>
                `).join('');
                
                const clearBtn = (activeFilters.length > 1) 
                    ? `<button class="clear-all-filters link subheading">Clear All</button>` 
                    : ``;
                
                menu.innerHTML = tagsHtml + clearBtn;
            }
        });

        // 3. Filter Grid Items
        items.forEach(item => {
            if (activeFilters.length === 0 || activeFilters[0] === "") {
                item.classList.remove("hidden");
                return;
            }
            const cat = item.getAttribute('data-category');
            const con = item.getAttribute('data-concern');
            const isMatch = activeFilters.includes(cat) || activeFilters.includes(con);
            item.classList.toggle("hidden", !isMatch);
        });

        document.dispatchEvent(new CustomEvent("theme:loading:start"));
        document.dispatchEvent(new CustomEvent("theme:loading:end"));
    };

    const updateURL = (activeArray) => {
        const url = new URL(window.location);
        // Filter out empty strings if any
        const cleanArray = activeArray.filter(f => f !== "");
        if (cleanArray.length > 0) {
            url.searchParams.set('filters', cleanArray.join(','));
        } else {
            url.searchParams.delete('filters');
        }
        window.history.pushState({}, '', url);
        applyFilter();
    };

    /**
     * Click Handler for Filters
     */
    filters.forEach(link => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            const val = link.getAttribute('data-filter');
            console.log(val);
            // Toggle logic in the staged array
            if (stagedFilters.includes(val)) {
                stagedFilters = stagedFilters.filter(f => f !== val);
            } else {
                stagedFilters.push(val);
            }
            if (!isMobile()) {
                // Desktop: Apply to URL immediately
                updateURL(stagedFilters);
            } else {
                // Mobile: Only toggle visual 'selected' state
                link.classList.toggle('selected', stagedFilters.includes(val));
                if (link.parentElement) {
                    link.parentElement.classList.toggle('selected', stagedFilters.includes(val));
                }
            }
        });
    });

    /**
     * Mobile Apply Button
     */
    if (applyBtn) {
        applyBtn.addEventListener('click', (e) => {
            e.preventDefault();
            updateURL(stagedFilters);
            // 1. Target the host element
            const host = document.querySelector('facets-drawer');

            // 2. Access the shadow root and find the internal element

            let closeButton;
            if(host) {
                closeButton = host.shadowRoot.querySelector('dialog-close-button');
            }                

            if(closeButton) closeButton.click();

        });
    }

    /**
     * Global Click Events (Immediate actions)
     */
    document.addEventListener('click', (e) => {
        // Tag "X" click
        if (e.target.classList.contains('remove-filter')) {
            const val = e.target.getAttribute('data-remove');
            const currentActive = stagedFilters.filter(f => f !== val);
            updateURL(currentActive);
        }
        
        // Clear All click
        if (e.target.classList.contains('clear-all-filters')) {
            updateURL([]);
        }
    });

    // Run on load
    applyFilter();
    window.addEventListener('popstate', applyFilter);
});